import { createBrowserRouter, Navigate, RouteObject } from 'react-router-dom';
import { AppShell } from 'src/ui/shell/AppShell';
import { TenantsPage } from 'src/ui/tenants/TenantsPage';
import { UsersPage } from 'src/ui/users/UsersPage';
import { AuditPage } from 'src/ui/audit/AuditPage';
import { NotFoundPage } from 'src/ui/system/NotFoundPage';
import { LoginPage } from 'src/ui/auth/LoginPage';
import { OverviewPage } from 'src/ui/overview/OverviewPage';

export const routes: RouteObject[] = [
  { path: '/login', element: <LoginPage /> },
  {
    path: '/',
    element: <AppShell />,
    children: [
      { index: true, element: <Navigate to="/overview" replace /> },
      { path: 'overview', element: <OverviewPage /> },
      { path: 'tenants', element: <TenantsPage /> },
      { path: 'users', element: <UsersPage /> },
      { path: 'audit', element: <AuditPage /> },
    ],
  },
  { path: '/404', element: <NotFoundPage /> },
  { path: '*', element: <Navigate to="/404" replace /> },
];

export default createBrowserRouter(routes as RouteObject[], {
  basename: import.meta.env.BASE_URL,
});
